export default {
  address: 'Indirizzo',
  contact: 'Contatti',
  terms: 'Termini di utilizzo',
  privacy_policy: 'Informativa sulla privacy',
  impressum: 'Impressum',
  cookie_policy: 'Informativa sui cookie',
  cookie_settings: 'Impostazioni cookie',
};
